export enum ValueTypeEnum {
  String = 'STRING',
  Numeric = 'NUMERIC',
  MultiValues = 'MULTI_VALUES',
  DynamicMultiValues = 'DYNAMIC_MULTI_VALUES',
  Date = 'DATE',
}
